import React, { useState } from "react";
import SearchWidget from "./widgets/SearchWidget";
import Sliderr from "./widgets/Slider";
import { Divider } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import * as homepage from "../../Homepage/_redux/homepageRedux";
import { makeStyles } from "@material-ui/core";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { Popover } from "@material-ui/core";
import { Modal } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { Player } from "video-react";
import { getAllIcons } from "../_redux/homepageCrud";
import mag1 from "../../../../ebusHomePics/1mag.jpg";
import EbusFirstCards from "./widgets/components/EbusFirstCards";
import MaskAndDiscount from "./widgets/components/MaskAndDiscount";
import EbusMobileIntroduction from "./widgets/components/EbusMobileIntroduction";
import MainPageFaq from "./widgets/components/MainPageFaq";
import mag2 from "../../../../ebusHomePics/2mag.jpg";
import axios from "axios";
import GoToWhyEbusLanding from "../../../pages/Landing/GoToWhyEbusLanding";
import Popup from "../../Popup/Popup";
import styled from "styled-components";

const FontSizeH2 = styled.div`
  font-size: calc(1.3rem + .6vw);
`;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(21),
    fontWeight: theme.typography.fontWeightRegular,
    // fontSize:theme.typography.fontSize=17,
  },
  des: {
    fontSize: theme.typography.pxToRem(18),
    lineHeight: "2",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  typography: {
    padding: theme.spacing(2),
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "blanchedalmond",
  border: "none",
  borderRadius: "13px",
  boxShadow: 24,
  p: 5,
};

const cards = [
  {
    id: 1,
    title: "سریع",
    desc: <p>سریع و بدون معطلی</p>,
    img: toAbsoluteUrl("media/ebusHomePics/stopwatch.png"),
  },
  {
    id: 2,
    title: "ارزان",
    desc: (
      <p>
        ارزان تر و مقرون به صرفه تر
        <br /> از هر جای دیگر بلیط تهیه کنید
      </p>
    ),
    img: toAbsoluteUrl("media/ebusHomePics/discount.png"),
  },
  {
    id: 3,
    title: "آسان",
    desc: (
      <p>
        با چند کلیک ساده
        <br /> بلیط تهیه و در کمال آرامش سفر کنید
      </p>
    ),
    img: toAbsoluteUrl("media/ebusHomePics/single-couch.png"),
  },
];

const secondCards = [
  {
    id: 1,
    title: "سفر به سلامت",
    img: toAbsoluteUrl("media/ebusHomePics/Mask.png"),
    desc: "توصیه های بهداشتی برای سفری سالم",
    className: "d-none d-lg-flex col-sm-12 col-md-6",
  },
  {
    id: 2,
    title: "اولین سفرت تخفیف بگیر",
    img: toAbsoluteUrl("media/ebusHomePics/3d-off.png"),
    desc: "تخفیف های متنوع و ویژه برای اولین سفرتان",
    className: "d-flex col-sm-12 col-lg-6",
  },
];

const EbusSliderItems = [
  {
    id: 1,
    title: "مسیر سفر تهران به رشت با اتوبوس ,قطار و هواپیما",
    description: ` برای بسیاری از پایتخت نشین ها که از آلودگی ناشی از آلاینده های هوا خسته
     شده اند`,
    className: "",
    img: mag1,
    link:
      "https://ebus.ir/mag/%d9%85%d8%b3%db%8c%d8%b1-%d8%b3%d9%81%d8%b1-%d8%aa%d9%87%d8%b1%d8%a7%d9%86-%d8%a8%d9%87-%d8%b1%d8%b4%d8%aa-%d8%a8%d8%a7-%d8%a7%d8%aa%d9%88%d8%a8%d9%88%d8%b3-%d8%8c-%d9%82%d8%b7%d8%a7%d8%b1-%d9%88/",
  },
  {
    id: 3,
    title: `راهنمای سفر به رشت ,شهر خلاق`,
    description: `  شهر رشت به دلیل قرار گرفتن در سواحل جنوبی دریای خزر بیشترین بارندگی را
        در بین مراکز استان ها دارد `,
    className: "",
    img: mag2,
    link:
      "https://ebus.ir/mag/%d8%b1%d8%a7%d9%87%d9%86%d9%85%d8%a7%db%8c-%d8%b3%d9%81%d8%b1-%d8%a8%d9%87-%d8%b1%d8%b4%d8%aa-%d8%8c-%d8%b4%d9%87%d8%b1-%d8%ae%d9%84%d8%a7%d9%82/",
  },
];

function Homepage(props, state) {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [arr, setArr] = useState('');

  const [isOpenPopup, setIsOpenPopup] = useState(true); // popup

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };




  React.useLayoutEffect(() => {
    console.log(`
    
██████████████   █████████████     ██████  ██████   ██████████████
██████████████   █░░░░░░░░░░██     ██░░██  ██░░██   ██░░░░░░░░░░██
██████████████   █░░██████░░██     ██░░██  ██░░██   ██░░██████████
                 █░░██  ██░░██     ██░░██  ██░░██   ██░░██
██████████████   █░░██████░░████   ██░░██  ██░░██   ██░░██████████
██████████████   █░░░░░░░░░░░░██   ██░░██  ██░░██   ██░░░░░░░░░░██
██████████████   █░░████████░░██   ██░░██  ██░░██   ██████████░░██
                 █░░██    ██░░██   ██░░██  ██░░██           ██░░██
██████████████   █░░████████░░██   ██░░██████░░██   ██████████░░██
██████████████   █░░░░░░░░░░░░██   ██░░░░░░░░░░██   ██░░░░░░░░░░██
██████████████   ███████████████   ██████████████   ██████████████
`,)

    console.log(`We're Hiring => https://ebus.ir/jobs-opportunities`)



    getAllIcons().then((res) => {
      props.setIcons(res.data.data);
    });
  }, []);

  return (
    <>

      {
        isOpenPopup && <Popup />
      }

      <div className="row" style={{ padding: "0px" }}>
        <div className="col-xl-12" style={{ padding: "0px" }}>
          <SearchWidget widgetHeight="200px" />
        </div>
      </div>
      <div className="row" style={{ padding: "0px" }}>
        <GoToWhyEbusLanding />
      </div>


      {/* <div
        style={{ marginBlock: "35px" }}
        className="row py-10 container mx-auto"
      >
        <EbusFirstCards cards={cards} />
      </div> */}

      <div className="d-flex my-5  container-md mx-auto justify-content-center">
        <MaskAndDiscount cards={secondCards} />
      </div>
      <div className="d-flex mt-15 pt-3 pb-3 container mx-auto">
        <FontSizeH2>
          <b>وبلاگ</b>
        </FontSizeH2>
      </div>
      <div
        className="row mt-5 mx-auto container"
        style={{ marginBottom: "5rem" }}
      >
        <Sliderr cards={EbusSliderItems} />
      </div>
      <div className="row mt-5 d-none d-lg-flex" id="mobileIntroDiv">
        <EbusMobileIntroduction />
      </div>
      <div
        className="row mt-5 pt-3 pb-3  container mx-auto"
        style={{ marginBottom: "8rem" }}
      >
        <div className="col-sm-12">
          <FontSizeH2
            style={{
              textAlign: "center",
              margin: "40px 25px 50px 25px",
              fontSize: "30px",
            }}
          >
            <b> "اتوبوس های ایباس رابهتر بشناسید" </b>
          </FontSizeH2>
          <div className="row">
            <div className="col-12 col-lg-6 mt-3">
              <Player
                preload={"metadata"}
                poster={toAbsoluteUrl("media/ebusHomePics/video-cover.webp")}
                src={"https://ebus.ir/Ebus.mp4"}
              />
            </div>
            <div className="col-12 col-lg-6 mt-3">
              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "26px",
                  textAlign: "justify",
                }}

              />

              ” ایباس اولین سامانه حمل و نقل هوشمند بین شهری اتوبوسی“ که
              فعالیت خود را از سال 1400 با هدف بهبود خدمات ارائه شده به
              مسافران ,آغاز کرده است. تا بتواند برای تمام افراد امکان سفری امن
              ,خدماتی مقرون به صرفه و با کیفیت بالا در ناوگان اتوبوسی فراهم
              کند. ما در این مسیر ملزم به اخذ مجوز‌های لازم برای ارائه خدمات
              قانونی به شما بودیم ,تمام فعالیت‌های ایباس قانونی بوده و تحت
              نظارت سازمان راهداری و حمل و نقل جاده ای کشور انجام می‌شود.
              ایباس یک پلتفرم قابل اعتماد و کارآمد که با شناسایی نیازهای مشتری
              و سنجش مشکلات سفرهای اتوبوسی به دنبال رفع مشکلات و برآورده کردن
              نیازهای اولیه مشتری با ارائه راه‌حل های لجستیک و مشتری مداری با
              تعهد به برتری و کیفیت خدمات به منظور رقابت و بهینه سازی هزینه‌ها
              و ایجاد شبکه امن در حمل و نقل عمومی می‌باشد.

            </div>
          </div>
        </div>
      </div>
      {/* <div className="row mt-5 pt-3 pb-3 my-3 container mx-auto">
        <Player>
          <source src={toAbsoluteUrl("media/ebusHomePics/Ebus.mp4")} />
        </Player>
      </div> */}
      <Divider
        className="w-100 mt-10"
        style={{ backgroundColor: "lightgray" }}
      />
      <MainPageFaq />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography className={classes.typography}>
            <ErrorOutlineOutlinedIcon
              className="mr-4"
              style={{ color: "green" }}
              fontSize="large"
            />
            این بخش به‌زودی فعال می‌شود
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
export default injectIntl(connect(null, homepage.actions)(Homepage));
